import React from "react";
import Collaborate from "../../TelaAdministrador/colaborar/CollaborateAdmin";
export default function Page() { return <Collaborate role="Comum" />; }
